<template>
<!--  <div id="nav">-->
<!--&lt;!&ndash;    <router-link to="/">Home</router-link> |&ndash;&gt;-->
<!--    <router-link to="/about">About</router-link>-->
<!--  </div>-->
	<router-view v-if="isRouterAlive"></router-view>
</template>
<script type="text/babel">

  export default {
    name: 'App',
	provide(){
	    return {
	      reload:this.reload
	    }
	  },
	data(){
		return{
			isRouterAlive:true
		}
	},
	methods:{
		reload () {
		     this.isRouterAlive = false
		     this.$nextTick(() => (this.isRouterAlive = true))
		   }
	},
	created() {
		this.$app.config.globalProperties.$AppContext=this;
	},
    computed: {
      invalidRoute () {
				// console.log(this.$route.matched)
        return !this.$route.matched || this.$route.matched.length === 0;
      },
    },
  };
</script>
<style lang="scss">
body {
    margin: 0;
  }

  .col {
    display: flex;
    flex-direction: column;
  }

  .row {

    display: flex;
    width: 100%;

  }

  .row-no-full {

    display: flex;
	
	
  }

  .nowrap {
    white-space: nowrap;
  }

  .center-row {

    justify-content: center;
  }

  .center-col {

    align-items: center;
  }



</style>
